<template>
  <div>
    <!-- <b-row>
      <b-col></b-col>
      <b-col md="8" lg="6">
        <b-input-group>
          <template #prepend>
            <label class="file">
              <i class="tim-icons icon-zoom-split"></i>
            </label>
          </template>
          <b-form-input
            type="text"
            :placeholder="$t('geral.search')"
            v-model="filter"
          >
          </b-form-input>
        </b-input-group>
      </b-col>
    </b-row> -->

    <div class="board">
      <div
        class="kanban-board-card perfect-scrollbar-on"
        v-for="tower in towers"
        :key="tower.name"
      >
        <!-- <task-lane
          :id="tower.name"
          :title="tower.name"
          :items="filtredCards(tower)"
          @refreshData="refreshData"
        ></task-lane> -->

        <!-- TaskLane - Begin -->
        <div class="card task-lane">
          <slot name="tower-header" v-bind:tower="tower">
            <h3 class="card-header">{{ tower.name }}</h3>
          </slot>

          <div class="card-body">
            <!-- <draggable v-model="draggables" :options="{ group: 'default' }"> -->

            <div v-for="item in filtredCards(tower)" :key="item.id">
              <div class="card task-lane-item">
                <div class="card-block">
                  <h5 class="card-title">
                    <slot name="card" v-bind:item="item" v-bind:tower="tower">
                      <!-- conteúdo fallback -->
                      <div>{{ item }}</div>
                    </slot>
                  </h5>
                </div>
              </div>
            </div>

            <!-- </draggable> -->
          </div>

          <div class="card-footer text-muted">
            <slot
              name="tower-footer"
              v-bind:amount="filtredCards(tower).length"
              v-bind:tower="tower"
            >
              <div v-if="filtredCards(tower).length === 1">
                {{ filtredCards(tower).length }} item
              </div>
              <div v-else>{{ filtredCards(tower).length }} itens</div>
            </slot>
          </div>
        </div>
        <!-- TaskLane - End -->
      </div>
    </div>
    <!-- <div>{{ towers }}</div> -->
  </div>
</template>

<script>
export default {
  name: "KanbanBoardSlot",
  props: {
    towers: Array,
  },
  data: function () {
    return {
      filter: "",
    };
  },
  computed: {
    todoItems() {
      return [
        { id: 1, text: "teste 1" },
        {
          id: 2,
          text: "teste 2 It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
        },
        { id: 3, text: "teste 3" },
      ];
    },
    inProgressItems() {
      return [
        { id: 4, text: "teste 4" },
        { id: 5, text: "teste 5" },
      ];
    },
    doneItems() {
      return [{ id: 6, text: "teste 6" }];
    },
  },
  methods: {
    filtredCards(tower) {
      if (!tower) return [];
      if (!tower.cards) return [];
      if (tower.cards.length == 0) return [];

      const filterToLower = this.filter.toLowerCase();
      let filtredCards = tower.cards.filter((card) => {
        return (
          card.id.toString().includes(filterToLower) ||
          card.text.toLowerCase().includes(filterToLower) ||
          card.elapsedTime.includes(filterToLower) ||
          card.checklistId?.includes(filterToLower)
        );
      });

      return filtredCards;
    },
    refreshData() {
      this.$emit("refreshData");
    },
  },
};
</script>

<style scoped>
.board {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  /* height: calc(100vh - 100px); */
  height: 100%;
}

.kanban-board-card {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  min-width: 300px;
}
.file {
  background: #2c3b5d;
  width: 3rem;
  height: 100%;
  padding-top: 8px;
  text-align: center;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
/* .file {
  border: 1px;
  border-color: #2b3553;
  border-style: solid;
  width: 3rem;
  height: 100%;
  margin-bottom: 1px;
  padding-top: 8px;
  padding-left: 14px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
} */

/* width */
/* ::-webkit-scrollbar {
  height: 15px;
  width: 15px;
} */

/* Track */
/* ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
} */

/* Handle */
/* ::-webkit-scrollbar-thumb {
  background: #627180; 
  border-radius: 10px;
} */

/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
  background: #627180; 
} */

/* TaskLane - Begin */
.card {
  min-height: 50px !important;
  /* width: 500px; */
  /* max-width: 400px !important;
  min-width: 300px !important; */
}
.card-body {
  overflow: auto;
  /* height: 100%; */
  /* height: calc(100vh - 270px); */
}

.task-lane {
  height: 100%;
  /* height: calc(100vh - 140px); */
  /* height: calc(100vh - 170px); */
}

/* width */
/* ::-webkit-scrollbar {
  width: 15px;
} */

/* Track */
/* ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
} */

/* Handle */
/* ::-webkit-scrollbar-thumb {
  background: #627180; 
  border-radius: 10px;
} */

/* Handle on hover */
/* ::-webkit-scrollbar-thumb:hover {
  background: #627180; 
} */
/* TaskLane - End */
</style>